var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaymanIslands(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0127C32 24.8492 24.8365 32.0127 16 32.0127C7.1635 32.0127 0 24.8492 0 16.0127C0 16.0165 16 0.0144453 16 0.0126953C24.8365 0.0126953 32 7.1762 32 16.0127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16.0128H16.0001C16.0001 15.9984 16.0001 15.9844 16.0001 15.9699C15.9858 15.9843 15.9716 15.9985 15.9573 16.0128Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.36051C16 5.5452 16 3.70051 16 0.0126953H15.9973C7.16194 0.0141953 0 7.17701 0 16.0127H8.34781V11.312L13.0485 16.0127H15.9572C15.9715 15.9984 15.9858 15.9842 16.0001 15.9699C16.0001 14.8919 16.0001 13.9301 16.0001 13.0613L11.2992 8.36051H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9563 11.8387C24.4931 11.8387 25.739 10.5929 25.739 9.05612C25.739 7.51932 24.4931 6.2735 22.9563 6.2735C21.4195 6.2735 20.1737 7.51932 20.1737 9.05612C20.1737 10.5929 21.4195 11.8387 22.9563 11.8387Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09454 2.09952C5.5921 3.52446 3.51167 5.60483 2.08679 8.10727V16.0126H6.26073V6.27358V6.27346H15.9999C15.9999 4.95702 15.9999 3.70289 15.9999 2.09952H8.09454Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.045L10.3153 8.36041H8.34778V8.36054L15.9998 16.0125H16C16 16.0125 16 14.6558 16 14.045V14.045Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 8.36032H27.8259V12.5343H18.0868V8.36032Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 18.7953V21.578H19.5508C20.4286 22.4382 21.6302 22.9693 22.9564 22.9693C24.2825 22.9693 25.4841 22.4382 26.3619 21.578H26.4346H27.8259V18.7953H18.0868Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 11.8387V16.0127C18.0868 19.7401 22.9564 20.8822 22.9564 20.8822C22.9564 20.8822 27.8259 19.7401 27.8259 16.0127V11.8387H18.0868Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 14.0684C21.7389 14.0684 21.7389 15.1814 20.5215 15.1814C19.3042 15.1814 19.3042 14.0684 18.0869 14.0684V16.0162C19.3042 16.0162 19.3042 17.1292 20.5215 17.1292C21.7389 17.1292 21.7389 16.0162 22.9562 16.0162C24.1736 16.0162 24.1736 17.1292 25.3911 17.1292C26.6086 17.1292 26.6085 16.0162 27.826 16.0162V14.0684C26.6086 14.0684 26.6086 15.1814 25.3911 15.1814C24.1736 15.1814 24.1736 14.0684 22.9562 14.0684V14.0684Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 10.1693C21.7389 10.1693 21.7389 11.2823 20.5215 11.2823C19.3042 11.2823 19.3042 10.1693 18.0869 10.1693V12.1171C19.3042 12.1171 19.3042 13.2302 20.5215 13.2302C21.7389 13.2302 21.7389 12.1171 22.9562 12.1171C24.1736 12.1171 24.1736 13.2302 25.3911 13.2302C26.6086 13.2302 26.6085 12.1171 27.826 12.1171V10.1693C26.6086 10.1693 26.6086 11.2823 25.3911 11.2823C24.1736 11.2823 24.1736 10.1693 22.9562 10.1693Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaymanIslands);
export default __webpack_public_path__ + "static/media/cayman-islands.888fe2b2.svg";
export { ForwardRef as ReactComponent };